module.exports = __webpack_public_path__ + "ClientApp/images/content/tampa-st-petersburg.jpg";